import { render, staticRenderFns } from "./single-work-dawn.vue?vue&type=template&id=24a0217b&scoped=true&lang=pug&"
import script from "./single-work-dawn.vue?vue&type=script&lang=js&"
export * from "./single-work-dawn.vue?vue&type=script&lang=js&"
import style0 from "./single-work-dawn.vue?vue&type=style&index=0&id=24a0217b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0217b",
  null
  
)

export default component.exports